module.exports = __webpack_public_path__ + "img/belgium.d25b2714.svg";